export enum LuckySpinStatus {
  Spinnable = 'spinnable',
  NotSpinnable = 'not_spinnable',
}
